import { Component } from '@angular/core';

@Component({
  selector: 'app-select-demo',
  templateUrl: './form-select-demo.component.html',
  styleUrls: ['./form-select-demo.component.scss'],
})
export class FormSelectDemoComponent {}
